import React from "react";


import styled from "styled-components";

import FormHOC from "hoc/FilltersForm";
import { debounce } from "utils";
import Text from "components/Form/Text";

import { Form, Schema } from "rsuite";

const { StringType } = Schema.Types;

const filtersModel = Schema.Model({
    str: StringType().maxLength(256, "The maximum is only 256 characters."),
});


const SearchFilter = ({ onChange, defaultFilters }) => {
    const handleChange = (formValues) => {
        onChange(formValues)
    };

    return (
        <>
            <Form
                model={filtersModel}
                layout="inline"
                onChange={debounce((value) => {
                    handleChange(value);
                }, 400)}
                formDefaultValue={defaultFilters}
            >
                <StyledTextField
                    name="str"
                    placeholder="Sender ID/Origin/Message"
                />
            </Form>
        </>
    );
};

export default FormHOC(SearchFilter, filtersModel, 300);

const StyledTextField = styled(Text)`
    &&& {
        width: 100%;
        min-width: 300px;
    }
`;